import React from 'react';
import PropTypes from 'prop-types';
import Link from '@utility/Link';
import cn from 'classnames';
import times from 'lodash.times';

const Pagination = ({ data: { currentPage, numPages, path } }) => (
  <div className="wrapper">
    <div className="pagination">
      <ul className="pagination-list">
        {times(numPages, (i) => {
          const page = i + 1;

          return (
            <li
              key={page}
              className={cn('pagination-item', {
                ['pagination-item--selected']: page === currentPage,
              })}
            >
              <Link
                to={`${path}${page === 1 ? '' : '/' + page}`}
                styled={false}
                aria-label={`Go to page #${page}`}
              >
                {page}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);

Pagination.propTypes = {
  data: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    numPages: PropTypes.number.isRequired,
    path: PropTypes.string.isRequired,
  }),
};

Pagination.defaultProps = {
  data: {},
};

export default Pagination;
